<template>
  <div>
    <v-card>
      <v-card-title class="text-h6">
        {{ $t('Supporting_Links') }} {{ links.length ? `(${links.length})` : '(0)' }}
        <template v-if="canShowShowButton">
          <v-tooltip :text="show ? $t('Hide') : $t('Show')" location="bottom">
            <template v-slot:activator="{ props }">
              <v-icon @click="show = !show" v-bind="props">{{ show ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
            </template>
          </v-tooltip>
        </template>
      </v-card-title>
      <v-card-text v-if="show">
        <div v-if="gettingLinks">{{ $t('Retrieving_Links') }}...</div>
        <template v-else>
          <v-container class="hidden-md-and-up">
            <v-row dense v-if="links.length">
              <v-col cols="12" sm="6" md="6" v-for="link in links" v-bind:key="link.id">
                <v-card>
                  <v-container>
                    <v-row dense>
                      <v-col>
                        <div>
                          <a v-bind:href="'//' + link.link" target="_blank">{{ link.link }}</a>
                        </div>
                        <div>
                          {{ link.title }}
                        </div>
                        <div>{{ (link.modifiedBy || {}).displayName }}</div>
                        <div>{{ $filters.DateTimeFilter(link.modifiedByDate) }}</div>
                      </v-col>
                      <v-col cols="1">
                        <div>
                          <a href="#" class="noUnder" @click.prevent="setupLinkDetails(link)">
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </a>
                        </div>
                        <div>
                          <a href="#" class="noUnder" @click.prevent="setupEdit(link)">
                            <v-icon>mdi-pencil-outline</v-icon>
                          </a>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense v-else>
              <v-col>
                {{ $t('No_Results') }}
              </v-col>
            </v-row>
          </v-container>
          <v-data-table class="hidden-sm-and-down table-layout-fixed-link" :headers="dataTableHeaders" :items="links">
            <template v-slot:item="props">
              <tr>
                <td>
                  <a v-bind:href="'//' + props.item.link" target="_blank">{{ props.item.link }}</a>
                </td>
                <td>
                  {{ props.item.title }}
                </td>
                <td>{{ (props.item.modifiedBy || {}).displayName }}</td>
                <td>{{ $filters.DateTimeFilter(props.item.modifiedByDate) }}</td>
                <td>
                  <a href="#" class="noUnder" @click.prevent="setupLinkDetails(props.item)">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </a>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>

    <toaster ref="toaster"></toaster>

    <v-dialog v-model="showLinkDetails" max-width="500">
      <v-card>
        <v-app-bar color="blue-grey" dense></v-app-bar>
        <v-card-title>{{ detailsLink.title }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col>
                <div>{{ $t('Created_By') }}: {{ (detailsLink.insertedBy || {}).displayName }}</div>
                <div>{{ $t('Created_On') }}: {{ $filters.DateTimeFilter(detailsLink.insertedByDate) }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <div>{{ $t('Modified_By') }}: {{ (detailsLink.modifiedBy || {}).displayName }}</div>
                <div>{{ $t('Modified_On') }}: {{ $filters.DateTimeFilter(detailsLink.modifiedByDate) }}</div>
              </v-col>
            </v-row>
            <strong>{{ $t('Versions') }}</strong>
            <template v-for="(version, index) in reversedLinkVersions" :key="index">
              <v-row dense align="center">
                <v-col cols="1">
                  <a class="noUnder" target="_blank" v-bind:href="version.link">
                    <v-icon>mdi-link</v-icon>
                  </a>
                </v-col>
                <v-col>
                  <div>{{ $t('Created_By') }}: {{ (version.insertedBy || {}).displayName }}</div>
                  <div>{{ $t('Created_On') }}: {{ $filters.DateTimeFilter(version.insertedByDate) }}</div>
                  <div>
                    <pre style="white-space: pre-wrap;">{{ version.comment || '' }}</pre>
                  </div>
                </v-col>
              </v-row>
            </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" text @click="showLinkDetails = false">{{ $t('Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ExternalService from '@/services/external.service'
import Toaster from '@/components/Toaster'

export default {
  name: 'SupportingLinks',
  components: {
    Toaster
  },
  data() {
    return {
      links: [],
      show: false,
      gettingLinks: false,
      showLinkDetails: false,
      detailsLink: {},
      dataTableHeaders: [
        { title: this.$t('Link'), key: 'link', width: '40%' },
        { title: this.$t('Title'), key: 'fileName' },
        { title: this.$t('Modified_By'), key: 'modifiedBy' },
        { title: this.$t('Modified_On'), key: 'modifiedByDate' },
        { title: '', key: '', sortable: false }
      ],
      csvExportConfig: {
        Title: 'title',
        Link: 'link',
        'Modified By': 'modifiedBy',
        'Modified On': 'modifiedByDate'
      }
    }
  },
  props: {
    moc: {
      type: Object
    }
  },
  computed: {
    reversedLinkVersions() {
      if (!this.detailsLink.versions) return []
      return this.detailsLink.versions.slice().reverse()
    },
    canShowShowButton: function() {
      return this.links.length > 0
    }
  },
  methods: {
    getLinks: function() {
      if (!this.moc.mocId) return
      if (!this.gettingLinks) {
        // get list of links for this moc
        this.gettingLinks = true
        return new Promise((resolve, reject) => {
          if (!this.moc.mocId) resolve()
          ExternalService.getMocSupportingLinks(this.moc.mocId)
            .then(data => {
              this.links = data
              resolve()
            })
            .catch(error => {
              console.error(error)
              this.$refs.loadingDialog.error({ message: this.$t('Error_GetLinks') })
            })
            .finally(() => {
              this.gettingLinks = false
            })
        })
      }
    },
    setupLinkDetails: function(link) {
      this.detailsLink = link
      this.showLinkDetails = true
    }
  },
  created() {
    this.getLinks()
  }
}
</script>
<style scoped>
.noUnder {
  text-decoration: none;
}
.title {
  font-size: 0.95rem !important;
  font-weight: 400;
}
.dropBox {
  border: 1px solid gray;
}
</style>
<style>
.table-layout-fixed-link table {
  table-layout: fixed;
}

.table-layout-fixed-link td {
  word-wrap: break-word;
}
</style>
